import useArticleImportRequest from "../useArticleImportRequest";
import React, { useState } from "react";
import apiUrl from "../../Apiurl";

function CSVuploadQuery32(props) {
  const uploadArticleCsv = useArticleImportRequest(props.utente);
  const [selectedFile, setSelectedFile] = useState();
  const [isFilePicked, setIsFilePicked] = useState(false);
  const [risultatoOperazione, setRisultatoOperazione] = useState(
    "In attesa dell'upload"
  );

  const changeHandler = (event) => {
    setSelectedFile(event.target.files[0]);
    setIsFilePicked(true);
  };

  const handleSubmission = () => {
    const formData = new FormData();

    formData.append("uploaded_file", selectedFile);

    uploadArticleCsv(apiUrl + "/csv", formData)
      .then((result) => {
        setRisultatoOperazione("Dati caricati correttamente");
        console.log("Success:", result);
      })
      .catch((error) => {
        setRisultatoOperazione(error.message);
        console.error("Error:", error);
      });
  };

  return (
    <div className="sfondoBiancoTema w-40 pa5 ma2 br4 shadow-4">
      <h1>Query 32</h1>
      <p>
        Importa i risultati ottenuti dalla query 32 su prestashop, così come
        sono stati generati dal sito
      </p>
      <input type="file" accept="csv" name="file" onChange={changeHandler} />
      {isFilePicked ? (
        <div>
          <p>Nome del file: {selectedFile.name}</p>
          <p>Tipo file: {selectedFile.type}</p>
          <p>Dimensione in bytes: {selectedFile.size}</p>
          <p>
            Data ultima modifica:{" "}
            {selectedFile.lastModifiedDate.toLocaleDateString()}
          </p>
        </div>
      ) : (
        <p>Seleziona un file</p>
      )}
      <div>
        <button
          onClick={handleSubmission}
          className="f6 link dim ba b--dark-green ph3 pv2 mt4 dib white bg-dark-green br3 mr2 w-70 center"
        >
          Carica
        </button>
      </div>
      <p>{risultatoOperazione}</p>
    </div>
  );
}

export default CSVuploadQuery32;
